import MasterModal from './master-modal.component'

export default MasterModal
